<template>
  <v-menu right>
    <v-btn slot="activator" icon>
      <v-icon color="grey lighten-2">more_vert</v-icon>
    </v-btn>

    <v-list class="menu-content">
      <v-list-tile @click="goConfigIcons">
        <v-list-tile-title class="white--text">Configurar íconos de áreas</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  methods: {
    goConfigIcons () {
      this.$router.push({ name: 'iconos' })
    }
  }
}
</script>

<style scoped>
.menu-content {
  background-color: #355487;
}
</style>
